import Cookies from 'universal-cookie'; const cookies = new Cookies();
function BackToPortal() {
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    window.location.replace(process.env.REACT_APP_PORTAL_DESTINATION + "api/dashboard/" + sessionToken);
}

export default BackToPortal